<script>
export default {
    name: "AllocateDepositForm",

    props: {

        deposits: Array,
        depositAllocation: Object,
        totalReceive: Number,
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <div class="w-full overflow-auto">
            <table class="table">
                <thead class="bg-blue-500 text-xs text-white">
                    <tr class="w-full flex">
                        <th class="p-tiny flex-1">Date</th>
                        <th class="p-tiny flex-1">Receipt No</th>
                        <th class="p-tiny flex-1">Allocated</th>
                        <th class="p-tiny flex-1">Unallocated</th>
                        <th class="p-tiny flex-1">Allocate</th>
                    </tr>
                </thead>
                <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height:20vh;">
                    <tr class="w-full flex" v-for="(patientDeposit, idx) in deposits" :key="idx">
                        <td class="p-tiny flex-1">{{ patientDeposit.trxDate | dateFormat }} </td>
                        <td class="p-tiny flex-1">{{ patientDeposit.receiptNo }}</td>
                        <td class="p-tiny flex-1">{{ patientDeposit.amountAllocated | numberFormat }}</td>
                        <td class="p-tiny flex-1">{{ patientDeposit.unAllocatedAmount | numberFormat }}</td>
                        <td class="p-tiny flex-1">
                            <label :for="`dep_${idx}`">
                                <input type="radio" 
                                    :disabled="patientDeposit.unAllocatedAmount < totalReceive ? true : false"
                                    :id="`dep_${idx}`"
                                    v-model="depositAllocation.allocations" 
                                    :value="{
                                        idx: idx,
                                        id: patientDeposit.id, 
                                        amount: totalReceive,
                                        receiptNo: patientDeposit.receiptNo,
                                        accountId:patientDeposit.accountID,
                                        paymentModeId:patientDeposit.paymentModeId,
                                    }">
                                {{ totalReceive | numberFormat }}</label>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="md:w-2/3 sm:w-full p-tiny">
            <label for="grid-memo" class="label-control">Memo:</label>
            <input type="text" v-model.trim="depositAllocation.memo" id="grid-memo" class="input-control input-sm text-xs">
        </div>
    </div>
</template>